module.exports = __webpack_public_path__ + "img/bond-insight.05314db1.svg";